import React, { useEffect, useState } from "react";
import "./ActivityAccordion.css";

function levelFor(count, max) {
  if (count === 0) return 0;
  return Math.min(4, 1 + Math.floor((3 * count) / max));
}

function monthLabels(weeks) {
  const labels = [];
  const seen = new Set();
  weeks.forEach((week, wi) => {
    const month = new Date(`${week[0].date}T00:00:00`).toLocaleString("en", {
      month: "short",
    });
    if (!seen.has(month)) {
      seen.add(month);
      labels.push({ wi, month });
    }
  });
  return labels;
}

/**
 * Collapsible GitHub contribution heatmap for the Professional section.
 * Renders nothing until the activity API answers, and stays hidden if the
 * API is unavailable — the section simply doesn't exist in that case.
 */
export default function ActivityAccordion() {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState(null);

  useEffect(() => {
    if (typeof fetch === "undefined") return;
    let cancelled = false;
    fetch("/api/github/activity")
      .then((r) => {
        if (!r.ok) throw new Error("unavailable");
        return r.json();
      })
      .then((d) => {
        if (!cancelled && d && d.weeks && d.weeks.length) setData(d);
      })
      .catch(() => {
        /* stay hidden */
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (!data) return null;

  const max = Math.max(1, ...data.weeks.flat().map((d) => d.count));
  const labels = monthLabels(data.weeks);

  return (
    <div className={`activity-acc${open ? " open" : ""}`}>
      <button
        className="activity-acc-head"
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
      >
        <span>
          Activity{" "}
          <span className="activity-acc-hint">— contributions on GitHub</span>
        </span>
        <span className="activity-acc-chev" aria-hidden="true">
          +
        </span>
      </button>
      <div className="activity-acc-body">
        <div className="activity-acc-inner">
          <div className="hm-total">
            <strong>{data.total.toLocaleString()}</strong> contributions in the
            last year
          </div>
          <div className="hm-scroll">
            <div className="hm-months">
              {labels.map(({ wi, month }) => (
                <span key={month} style={{ left: wi * 14 }}>
                  {month}
                </span>
              ))}
            </div>
            <div className="hm-body">
              <div className="hm-days">
                <span />
                <span>Mon</span>
                <span />
                <span>Wed</span>
                <span />
                <span>Fri</span>
                <span />
              </div>
              <div className="hm-cells">
                {data.weeks.flat().map((d) => (
                  <div
                    key={d.date}
                    className={`hm-cell l${levelFor(d.count, max)}`}
                    title={`${d.count} contributions on ${d.date}`}
                  />
                ))}
              </div>
            </div>
          </div>
          <div className="hm-legend">
            Less
            {[0, 1, 2, 3, 4].map((l) => (
              <span key={l} className={`hm-cell l${l}`} />
            ))}
            More
          </div>
        </div>
      </div>
    </div>
  );
}
